import { request } from '../../../utils/request'
import { GET_AUTHORIZATION_DATA_URL } from './utils'
import { authorizationDataSchema } from './validators'

export async function getAuthorizationData() {
  const { data } = await request(GET_AUTHORIZATION_DATA_URL())

  return authorizationDataSchema.validate(data)
}
